// ─────────────────────────────────────────────────────────────────────────────
// Shared chart color palette + helpers for the Reports feature.
//
// Used by BOTH the dynamic (on-screen) report view (ReportDetailsDialog.tsx,
// via recharts) and the PDF export (reportPDFGenerator.ts, via jsPDF vector
// drawing) so the two stay visually consistent.
//
// Colors intentionally mirror the PALETTE already used on the main dashboard
// (admin/src/admin/pages/dashboard/dashboard.tsx) so charts look like one
// system across the admin app.
// ─────────────────────────────────────────────────────────────────────────────

export const CHART_PALETTE = {
  blue: '#3b82f6',
  green: '#10b981',
  amber: '#f59e0b',
  red: '#ef4444',
  teal: '#5A9FB5',
  violet: '#8B7AA8',
  slate: '#5B7C99',
  sage: '#69A884',
  tan: '#B8956A',
  mauve: '#A67C8E',
  mist: '#7A9B8E',
};

// Fixed-order categorical series — never cycle/reassign per filter change.
export const CHART_SERIES_COLORS: string[] = [
  CHART_PALETTE.slate,
  CHART_PALETTE.teal,
  CHART_PALETTE.violet,
  CHART_PALETTE.sage,
  CHART_PALETTE.amber,
  CHART_PALETTE.mauve,
  CHART_PALETTE.tan,
  CHART_PALETTE.mist,
  CHART_PALETTE.blue,
  CHART_PALETTE.red,
];

// Status/semantic color keys, matching the getSoftChipSx color keys used
// throughout the Reports feature (success/warning/error/info/primary/secondary/default).
export const STATUS_CHART_COLORS: Record<string, string> = {
  success: CHART_PALETTE.green,
  warning: CHART_PALETTE.amber,
  error: CHART_PALETTE.red,
  info: CHART_PALETTE.teal,
  primary: CHART_PALETTE.blue,
  secondary: CHART_PALETTE.violet,
  default: CHART_PALETTE.slate,
};

export function colorForSeriesIndex(i: number): string {
  return CHART_SERIES_COLORS[i % CHART_SERIES_COLORS.length];
}

export function hexToRgb(hex: string): { r: number; g: number; b: number } {
  const clean = hex.replace('#', '');
  const full = clean.length === 3 ? clean.split('').map(c => c + c).join('') : clean;
  const bigint = parseInt(full, 16);
  return { r: (bigint >> 16) & 255, g: (bigint >> 8) & 255, b: bigint & 255 };
}
